import React, { useEffect } from 'react'

import './bandeira-taxa.scss'
import _ from 'lodash'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { DataTable } from 'primereact/datatable'
import { icons } from '../../../constants'
import utils from '../../../utils'

export default function BandeiraTaxa(props) {
  useEffect(() => {}, [])

  const columns = [
    {
      field: 'parcelaInicial',
      header: utils.getMessage(props.messages, 'bandeira.label.parcelaInicial'),
      columnKey: 'parcelaInicial',
      sortable: true,
      filter: false,
    },
    {
      field: 'parcelaFinal',
      header: utils.getMessage(props.messages, 'bandeira.label.parcelaFinal'),
      columnKey: 'parcelaFinal',
      sortable: true,
      filter: false,
    },
    {
      field: 'taxa',
      header: utils.getMessage(props.messages, 'bandeira.label.percentualTaxa'),
      columnKey: 'taxa',
      sortable: true,
      filter: false,
    },
    {
      field: 'diasCredito',
      header: utils.getMessage(props.messages, 'bandeira.label.diasCredito'),
      columnKey: 'diasCredito',
      sortable: true,
      filter: false,
    },
    {
      field: 'acoes',
      header: utils.getMessage(props.messages, 'bandeira.label.acoes'),
      columnKey: 'acoes',
    },
  ]

  const resolveColumns = () => {
    return columns.map((col) => {
      col.showFilterMenuOptions = false
      col.showClearButton = false
      col.showFilterMenu = false

      if (col.field === 'parcelaInicial' || col.field === 'parcelaFinal' || col.field === 'diasCredito') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-parcela-inicial-final-body-width"
            headerClassName="column-parcela-inicial-final-header-width"
            filterHeaderClassName="column-parcela-inicial-final-filter-header-width"
          />
        )
      }

      if (col.field === 'taxa') {
        return (
          <Column
            {...col}
            key={col.field}
            body={formatColumn}
            bodyClassName="column-taxa-body-width"
            headerClassName="column-taxa-header-width"
            filterHeaderClassName="column-taxa-filter-header-width"
          />
        )
      }

      if (col.field === 'acoes') {
        return (
          <Column
            {...col}
            key={col.field}
            body={actions}
            bodyClassName="column-acoes-body-width"
            headerClassName="column-acoes-header-width"
            filterHeaderClassName="column-acoes-filter-header-width"
          />
        )
      }
      return null
    })
  }

  const actions = (rowData) => {
    return (
      <div>
        <Button
          type="button"
          icon={icons.REMOVE_ICON}
          className="p-button-danger"
          onClick={(e) => removeTaxa(e, rowData)}
        />
      </div>
    )
  }

  const removeTaxa = (e, data) => {
    e.preventDefault()
    e.stopPropagation()
    props.onClickRemoveTaxa(data)
  }

  const formatColumn = (rowData, column) => {
    const field = _.get(column, 'field', '')
    if (field === 'parcelaInicial' || field === 'parcelaFinal' || field === 'diasCredito') {
      return _.get(rowData, field, null)
    }
    if (field === 'taxa') {
      return _.get(rowData, field, 0)
    }
    return null
  }

  return (
    <React.Fragment>
      <div className="p-grid form-group" style={{ marginTop: '15px' }}>
        <div className="p-col-12">
          <DataTable
            emptyMessage=" "
            value={props.values}
            resizableColumns={true}
            columnResizeMode="expand"
            filterDisplay="row"
            size={'small'}
            stripedRows={true}
            responsiveLayout="scroll"
            scrollable={true}
            scrollHeight="400px"
          >
            {resolveColumns()}
          </DataTable>
        </div>
      </div>
    </React.Fragment>
  )
}
